<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  (validate)="onValidate($event)"
>
  <div class="m-2 before-submit" [formGroup]="getControl('data')">
    <h1 class="section-header">
      {{ "BEFORE_SUBMIT_STATIC_TEXT18" | globalTranslate }}
    </h1>
    <hr />
    <div>
      @if (hideHealthPlanText) {
      <p
        class="static-text"
        [innerHTML]="'BEFORE_SUBMIT_STATIC_TEXT19' | globalTranslate"
      ></p>
      } @if (showHealthPlanText) {
      <p
        class="static-text"
        [innerHTML]="'BEFORE_SUBMIT_STATIC_TEXT19_01' | globalTranslate"
      ></p>
      }
      <div class="row" style="margin-bottom: 10px">
        <div class="col-md-5">
          <label for="healthPlanMCO" class="label-section">{{
            "BEFORE_SUBMIT_STATIC_TEXT20" | globalTranslate
          }}</label>
          @if (hideHealthPlanText) {
          <select
            id="ch_healthPlan"
            nh
            name="healthPlan"
            [attr.aria-label]="'BEFORE_SUBMIT_STATIC_TEXT20' | globalTranslate"
            [items]="tableCodeValue('MCONAME', 'data.healthPlan')"
            formControlName="healthPlan"
          ></select>
          } @if (showHealthPlanText) {
          <select
            id="ch_healthPlan"
            nh
            name="healthPlan"
            [attr.aria-label]="'BEFORE_SUBMIT_STATIC_TEXT20' | globalTranslate"
            [items]="tableCodeValue('MCONAME_UBW', 'data.healthPlan')"
            formControlName="healthPlan"
          ></select>
          }
        </div>
        <div class="col-md-6" style="margin-top: 17px">
          <button
            (click)="openHealthPlansModal()"
            class="btn healthplan-more-info"
            [ngClass]="{ 'width-translate': increaseWidth() }"
          >
            {{ "MOREINFO_BUTTON_TEXT" | globalTranslate }}
          </button>
        </div>
      </div>

      <p class="static-text">
        <span
          [innerHTML]="'BEFORE_SUBMIT_STATIC_TEXT21' | globalTranslate"
        ></span>
        <a
          target="_blank"
          href="https://www.tn.gov/tenncare/members-applicants/managed-care-organizations.html"
          ><b> {{ "BEFORE_SUBMIT_STATIC_TEXT22" | globalTranslate }}</b></a
        >.
      </p>
      <p
        class="static-text"
        [innerHTML]="'BEFORE_SUBMIT_STATIC_TEXT23' | globalTranslate"
      ></p>
    </div>
  </div>
</nh-form>